var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
var countdownTimeout;
export function useCountdown(startTime) {
    if (startTime === void 0) { startTime = 1; }
    var _a = __read(useState(startTime * 60), 2), time = _a[0], setTime = _a[1];
    var _b = __read(useState(false), 2), isActive = _b[0], setIsActive = _b[1];
    var _c = __read(useState(false), 2), hasFinished = _c[0], setHasFinished = _c[1];
    var seconds = time;
    function startCountdown() {
        setIsActive(true);
    }
    function resetCountdown() {
        clearTimeout(countdownTimeout);
        setIsActive(false);
        setHasFinished(false);
        setTime(startTime * 60);
    }
    useEffect(function () {
        if (isActive && time > 0) {
            countdownTimeout = setTimeout(function () {
                setTime(time - 1);
            }, 1000);
        }
        else if (isActive && time === 0) {
            setHasFinished(true);
            setIsActive(false);
        }
    }, [isActive, time]);
    return {
        seconds: seconds,
        isActive: isActive,
        hasFinished: hasFinished,
        startCountdown: startCountdown,
        resetCountdown: resetCountdown,
    };
}
